require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M46.668 11.563a17.801 17.801 0 0 1-5.11 1.398 8.884 8.884 0 0 0 3.91-4.918 17.88 17.88 0 0 1-5.648 2.16 8.864 8.864 0 0 0-6.488-2.808 8.89 8.89 0 0 0-8.89 8.89c0 .695.081 1.375.23 2.024-7.387-.372-13.938-3.91-18.324-9.29a8.878 8.878 0 0 0-1.2 4.47 8.871 8.871 0 0 0 3.954 7.398 8.89 8.89 0 0 1-4.028-1.11v.11a8.894 8.894 0 0 0 7.13 8.718 8.878 8.878 0 0 1-4.013.153 8.897 8.897 0 0 0 8.305 6.176 17.847 17.847 0 0 1-11.043 3.804c-.715 0-1.426-.039-2.121-.125a25.15 25.15 0 0 0 13.629 3.996c16.352 0 25.293-13.547 25.293-25.297 0-.382-.008-.765-.027-1.148a18.088 18.088 0 0 0 4.441-4.602zm0 0"
  }));
};

exports["default"] = _default;